import { render } from "./RankListView.vue?vue&type=template&id=64c5ba08"
import script from "./RankListView.vue?vue&type=script&lang=js"
export * from "./RankListView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__